"use strict";

angular.module("core")
.controller("PreAuthorizedPaymentAgreementModalController", function(
    $rootScope, $scope, $attrs, $timeout, close, Language
) {
    $scope.agreement = $attrs.agreement;

    var controller = this;
    var unregister = Language.initializeController(this, "language", null);
    var unregisterLanguageChanged = $rootScope.$on("LanguageChanged", function(evt, new_locale, new_language) {
        controller.language = new_language;
    });

    $scope.isPDFLoaded = false;
    $scope.isPDFError = false;

    if ($scope.agreement && $scope.agreement.file && $scope.agreement.file.url) {
        $scope.pdfUrl = $scope.agreement.file.url;
    } else {
        $scope.pdfUrl = false;
    }

    $scope.onLoad = function() {
        $scope.isPDFLoaded = true;
    }

    $scope.onError = function(error) {
        $timeout(function() {
            $scope.isPDFError = true;
        });
    }

    $scope.$on("$destroy", function() {
        unregisterLanguageChanged();
        unregister();
    });

    $scope.close = function() {
        $scope.$element.modal("hide");
        $scope.$element.remove();
        close.apply(this, arguments);
    };
});



//////////////////
// WEBPACK FOOTER
// ./core/pre-authorized-payment-agreement-button/modal/pre-authorizer-payment-agreement.modal.js
// module id = 671
// module chunks = 0